module.exports = __webpack_public_path__ + "static/media/specials.ce06e8da.png";